import { useEffect } from 'react';
import { useFormikContext } from 'formik';
export const ValueChangeHandler = ({ value, onChange, }) => {
    const context = useFormikContext();
    useEffect(() => {
        onChange(value, context);
    }, [value, onChange]);
    return null;
};
